import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function RealEstateCard({ result = [] }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          <Box sx={{ height: 25, width: 25, mr: 1, overflow: 'hidden' }}>
            <img src="/images/Immobilier.png" alt="" />
          </Box>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.markeet.realEstate.title')}</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray' }}>{t('investments.markeet.realEstate.subtitle')}</Box>
        </Box>
      </Box>
      <Box mt={1} height={'100%'} display={'flex'} flexDirection={'column'} gap={1}>
        {result.map((item, index) => (
          <Box key={index} display={'flex'}>
            <Box
              sx={{
                width: 150,
                display: 'flex',
                justifyContent: 'center',
                overflow: 'hidden',
                mr: '8px',
              }}
            >
              <img src={item.image} alt="" />
            </Box>
            <Box>
              <Box>
                {item.name} {parseFloat(item.price).toFixed(0)} €
                <Box component={'span'} color={'green'}>
                  {' '}
                  {parseFloat(item.prix_m2)}€/m2
                </Box>
              </Box>
              <Box color={'gray'}>
                <Box>
                  {item.superficie_m2} m2 {'  '}
                  {item.localisation}
                </Box>
                {/* LAP-733 (GE022) */}
                <Box>{t('investments.markeet.realEstate.annualRent')}: {item.loyer_mensuel * 12}€</Box>
                <Box>
                  {/* LAP-733 (GE022) */}
                  {t('investments.markeet.realEstate.grossYield')}:{' '}
                  <Box component={'span'} ml={1} color={item.rendement >= 0 ? 'green' : 'red'}>
                    {item.rendement}%
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
